import * as React from "react"
import { useEffect } from "react"
import { Grid } from "@mui/material"

import { SKU_CANDIDATES_ROUTES } from "@constants"
import PageWrapper from "Pages/@PageWrapper"
import { clearSkuCandidatesSignals } from "./@signals"
import { useSkuCandidates } from "./@hooks"
import SkuCandidatesFilters from "./Filters"
import SkuCandidatesTable from "./Table"
import StatsCards from "./StatsCards"
import CreateSkuDrawer from "./CreateSkuDrawer"
import MapToSkuDrawer from "./MapToSkuDrawer"
import ImageModal from "./ImageModal"
import ImageComparisonModal from "./ImageComparisonModal"


export default function SkuCandidatesPage() {
    // Initialize hook to handle data fetching
    useSkuCandidates()

    useEffect(() => {
        return clearSkuCandidatesSignals
    }, [])

    return <PageWrapper
        head={SKU_CANDIDATES_ROUTES.TITLE}
        title={SKU_CANDIDATES_ROUTES.TITLE}
        subtitle={SKU_CANDIDATES_ROUTES.SUBTITLE}
        actions={null}
    >
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <SkuCandidatesFilters />
            </Grid>

            <Grid item xs={12}>
                <StatsCards />
                <SkuCandidatesTable />
            </Grid>
        </Grid>

        <CreateSkuDrawer />
        <MapToSkuDrawer />
        <ImageModal />
        <ImageComparisonModal />
    </PageWrapper>
}
